export default __webpack_public_path__ + "static/media/img_post7_1.25ec22b1.png";